'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('shared/runtime', ['require'], function (require) {
  'use strict';

  var lang = 'en-us';
  var env = $('meta[name=wano-runtime-env]').attr('content');
  var hostInfo = $('meta[name=wano-env-host-info]').attr('content');

  /**
   * 运行环境工具类
   */

  var Runtime = function () {
    function Runtime() {
      _classCallCheck(this, Runtime);
    }

    _createClass(Runtime, [{
      key: 'changeLocale',


      /**
       * 更新站点语言，更新后将 reload 页面
       *
       * @param {string} targetLocale 待更换语言 zh-cn | en-us ｜ es-es ｜ pt-pt
       */
      value: function changeLocale(targetLocale) {
        // 切换时不检查当前语言，可能在其它页面已改变 cookie
        var newSearch = '?__locale=' + targetLocale + (location.search ? '&' : '') + location.search.replace(/^\?/, '');
        location.replace('' + location.pathname + newSearch + location.hash);
      }
    }, {
      key: 'locale',


      /**
       * 获取当前语言
       *
       * @return {string} 固定 en-us
       */
      get: function get() {
        return lang;
      }

      /**
       * 获取当前环境标识，与 server 保持一致
       *
       * @return {string} local | unittest | prod
       */

    }, {
      key: 'env',
      get: function get() {
        return env;
      }

      /**
       * 获取当前的域名信息，统一由server层下发 逻辑控制。
       *
       * @return {string} hostInfo
       */

    }, {
      key: 'hostInfo',
      get: function get() {
        return JSON.parse(hostInfo);
      }
    }]);

    return Runtime;
  }();

  return new Runtime();
});